<template>
  <div>
    <el-dialog
      :model-value="visible"
      :title="destroyId > 0 ? lang('account.remove.title3') : lang('account.remove.title')"
      :before-close="handleClose"
      :width="640"
    >
      <div style="font-weight: bold">{{ lang('account.remove.content1') }}</div>
      <div>{{ lang('account.remove.content2') }}</div>
      <div>{{ lang('account.remove.content3', [days]) }}</div>
      <div>{{ lang('account.remove.content4', [days]) }}</div>
      <div>{{ lang('account.remove.content5', [days]) }}</div>
      <div>{{ lang('account.remove.content6') }}</div>

      <template #footer>
        <template v-if="destroyId > 0">
          <div class="tip">{{ lang('account.remove.removeTip', [destroyTime]) }}</div>
          <el-button type="primary" @click="handleUndoDetect">
            {{ lang('account.remove.undoDetect') }}
          </el-button>
        </template>
        <template v-else>
          <el-button type="danger" @click="handleConfirm">
            {{ lang('account.remove.removeText1') }}
          </el-button>
          <el-button type="primary" @click="handleClose">
            {{ lang('mainTip.logout.cancel') }}
          </el-button>
        </template>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import { ElDialog, ElButton, ElMessage, ElMessageBox } from 'element-plus'
import { defineComponent } from 'vue'
import { $t as lang } from '@/Tool'
import api from '@/services'

export default defineComponent({
  props: ['visible', 'destroyId', 'destroyTime', 'days'],
  components: { ElDialog, ElButton },
  setup(props, { emit }) {
    function handleClose() {
      emit('close')
    }

    function handleConfirm() {
      emit('confirm')
    }

    async function handleUndoDetect() {
      emit('close')

      ElMessageBox.confirm(
        lang('account.remove.confirmText'),
        lang('account.remove.undoDetectTitle'),
        {
          type: 'warning',
          confirmButtonText: lang('account.remove.confirmUndo'),
          cancelButtonText: lang('mainTip.logout.cancel'),
          center: true,
        },
      ).then(async () => {
        const { success } = await api.Scrm_sys_api.userDetect.undoDetect({
          id: props.destroyId,
        })
        if (success) {
          ElMessage.success(lang('account.remove.undoDetectOkTip'))
          emit('success')
        } else {
          ElMessage.error(lang('account.remove.undoDetectFailTip'))
        }
      })
    }

    return {
      lang,
      handleUndoDetect,
      handleConfirm,
      handleClose,
    }
  },
})
</script>

<style lang="scss" scoped>
:deep(.el-dialog) {
  border-radius: 8px;
}
:deep(.el-dialog__header) {
  text-align: center;
  padding-top: 49px;
}
:deep(.el-dialog__title) {
  font-size: 20px;
  font-weight: bold;
  color: #000;
}
:deep(.el-dialog__body) {
  font-size: 14px;
  line-height: 27px;
  color: #000;
  padding: 20px 49px;
}
:deep(.el-dialog__footer) {
  text-align: center;
  .tip {
    margin-bottom: 10px;
    font-size: 14px;
    color: #c6c6c6;
  }
  .el-button {
    width: 217px;
    height: 38px;
    border-radius: 4px;
    font-size: 12px;
    &--danger {
      background-color: #d61818;
    }
  }
}
</style>
